import { Button, Card, Dialog } from '@mui/material';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { ContentsSelectors } from '@data/contents/Contents.selectors';
import { deleteContents } from '@data/contents/Contents.thunk';
import useAppDispatch from '@data/useAppDispatch';
import { LoadingButton } from '@mui/lab';
import { Content } from '@data/contents/Contents.model';

export interface ContentDeleteModalProps {
  selectedContentIds: string[];
  resetSelectedContents: () => void;
  onClose: () => void;
}

export const ContentDeleteModal = (props: ContentDeleteModalProps) => {
  const { selectedContentIds, onClose, resetSelectedContents } = props;

  const filteredList = useSelector((state: any) =>
    ContentsSelectors.contents.selectByIds(state, selectedContentIds),
  ) as Content[];

  const [isLoading, setIsLoading] = React.useState(false);

  const dispatch = useAppDispatch();
  const handleDelete = () => {
    setIsLoading(true);
    // Dispatch an action to delete the selected contents
    dispatch(
      deleteContents({
        contentIds: selectedContentIds,
      }),
    ).then((_) => {
      resetSelectedContents();
      onClose();
      setIsLoading(false);
    });
    onClose();
  };

  return (
    <Dialog open>
      <Card className="pt-10 w-[371px] flex-col-center p-[20px]">
        <div className="w-full text-left h4 text-brand-primary">
          Deleting Content
        </div>
        <div className="w-full max-h-full mt-2 h4 text-brand-secondary">
          Are you sure you want to delete these content?
          <ul className="mb-8">
            {filteredList.map((content) => (
              <li key={content.id} className="flex mt-2">
                <span
                  style={{
                    marginTop: '0.5rem',
                    fontSize: '6px',
                    marginRight: '0.5rem',
                    marginLeft: '1rem',
                  }}
                >
                  {'\u2B24'}
                </span>
                <span>{content.title}</span>
              </li>
            ))}
          </ul>
          <span className="font-bold subtitle1">
            Any Series will be removed from all interactions and no longer
            visible in the Discover section.{' '}
            <span className="text-error">All progress will be reset.</span>
          </span>
        </div>
        <div className="flex justify-center mt-[30px]">
          <Button
            onClick={onClose}
            variant="outlined"
            color="primary"
            className="w-[130px] h-[40px] !mr-[10px] !ml-[10px]"
            disabled={isLoading}
          >
            Cancel
          </Button>
          <LoadingButton
            onClick={handleDelete}
            className="w-[130px] h-[40px] !mr-[10px] !ml-[10px]"
            variant="contained"
            color="primary"
            loading={isLoading}
          >
            Confirm
          </LoadingButton>
        </div>
      </Card>
    </Dialog>
  );
};
